import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../App';
import { t } from '../i18n';
import LanguageToggle from '../components/game/LanguageToggle';

export default function PrivacyPage() {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const isEN = language === 'en';

  return (
    <div className="legal-page">
      <div className="legal-header">
        <button className="setup-back-btn" onClick={() => navigate(-1)}>&larr; {t('backToHome', language)}</button>
        <LanguageToggle />
      </div>
      <div className="legal-content">
        <h1>{isEN ? 'Privacy Policy' : 'Dasar Privasi'}</h1>
        <p className="legal-date">{isEN ? 'Last updated: February 2026' : 'Kemas kini terakhir: Februari 2026'}</p>

        <h2>{isEN ? '1. Information We Collect' : '1. Maklumat Yang Kami Kumpul'}</h2>
        <p>{isEN ? 'When you use PANTASS, we collect:' : 'Apabila anda menggunakan PANTASS, kami mengumpul:'}</p>
        <ul>
          <li>{isEN ? 'Account information: name, email address, school name (optional)' : 'Maklumat akaun: nama, alamat e-mel, nama sekolah (pilihan)'}</li>
          <li>{isEN ? 'Game data: scores, progress, achievements, match history' : 'Data permainan: markah, kemajuan, pencapaian, sejarah perlawanan'}</li>
          <li>{isEN ? 'Payment information: processed securely through Stripe (we do not store card details)' : 'Maklumat pembayaran: diproses dengan selamat melalui Stripe (kami tidak menyimpan butiran kad)'}</li>
        </ul>

        <h2>{isEN ? '2. How We Use Your Information' : '2. Bagaimana Kami Menggunakan Maklumat Anda'}</h2>
        <ul>
          <li>{isEN ? 'To provide and improve our educational game services' : 'Untuk menyediakan dan meningkatkan perkhidmatan permainan pendidikan kami'}</li>
          <li>{isEN ? 'To track learning progress and generate reports' : 'Untuk menjejak kemajuan pembelajaran dan menjana laporan'}</li>
          <li>{isEN ? 'To manage subscriptions and process payments' : 'Untuk mengurus langganan dan memproses pembayaran'}</li>
          <li>{isEN ? 'To display leaderboards and school rankings' : 'Untuk memaparkan papan markah dan kedudukan sekolah'}</li>
        </ul>

        <h2>{isEN ? '3. Data Security' : '3. Keselamatan Data'}</h2>
        <p>{isEN ? 'We implement industry-standard security measures including encrypted passwords (bcrypt), secure JWT authentication, rate limiting, and HTTPS encryption. Payment processing is handled by Stripe, a PCI-compliant payment processor.' : 'Kami melaksanakan langkah keselamatan standard industri termasuk kata laluan yang disulitkan (bcrypt), pengesahan JWT yang selamat, had kadar, dan penyulitan HTTPS. Pemprosesan pembayaran dikendalikan oleh Stripe, pemproses pembayaran yang mematuhi PCI.'}</p>

        <h2>{isEN ? '4. Children\'s Privacy' : '4. Privasi Kanak-Kanak'}</h2>
        <p>{isEN ? 'PANTASS is designed for children aged 5-17. We collect minimal personal information from children. Parent or teacher consent is required for account creation. We do not sell or share children\'s personal data with third parties for marketing purposes.' : 'PANTASS direka untuk kanak-kanak berumur 5-17 tahun. Kami mengumpul maklumat peribadi minimum daripada kanak-kanak. Kebenaran ibu bapa atau guru diperlukan untuk penciptaan akaun. Kami tidak menjual atau berkongsi data peribadi kanak-kanak dengan pihak ketiga untuk tujuan pemasaran.'}</p>

        <h2>{isEN ? '5. Third-Party Services' : '5. Perkhidmatan Pihak Ketiga'}</h2>
        <p>{isEN ? 'We use the following third-party services:' : 'Kami menggunakan perkhidmatan pihak ketiga berikut:'}</p>
        <ul>
          <li><strong>Google OAuth</strong> — {isEN ? 'for secure login authentication' : 'untuk pengesahan log masuk yang selamat'}</li>
          <li><strong>Stripe</strong> — {isEN ? 'for payment processing' : 'untuk pemprosesan pembayaran'}</li>
          <li><strong>MongoDB Atlas</strong> — {isEN ? 'for secure data storage' : 'untuk penyimpanan data yang selamat'}</li>
        </ul>

        <h2>{isEN ? '6. Your Rights' : '6. Hak Anda'}</h2>
        <p>{isEN ? 'You have the right to access, correct, or delete your personal data at any time. Contact us at support@pantass.com to exercise these rights.' : 'Anda berhak untuk mengakses, membetulkan, atau memadam data peribadi anda pada bila-bila masa. Hubungi kami di support@pantass.com untuk melaksanakan hak ini.'}</p>

        <h2>{isEN ? '7. Contact Us' : '7. Hubungi Kami'}</h2>
        <p>{isEN ? 'If you have any questions about this Privacy Policy, please contact us at:' : 'Jika anda mempunyai sebarang soalan tentang Dasar Privasi ini, sila hubungi kami di:'}</p>
        <p><strong>Email:</strong> support@pantass.com</p>
      </div>
    </div>
  );
}
